var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-accent"},[_c('md-card-header',[_c('md-icon',[_vm._v("error_outline")]),_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.type)+" Error")])],1),_c('md-card-content',[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }